import { useEffect } from 'react';
import { useLocation } from 'react-router';

import type { Props as Options } from '#src/atoms/markdown/Markdown/index.tsx';
// only place where Markdown can be imported
// eslint-disable-next-line no-restricted-imports
import { Markdown } from '#src/atoms/markdown/Markdown/index.tsx';

export type Props = Options;

export const Content = (props: Props) => {
  const { hash } = useLocation();

  useEffect(() => {
    // if a hash link, find it
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView(true);
        }
      }, 0);
    }
  }, [hash]); // do this on route change
  return <Markdown {...props} />;
};
